<template>
    <el-dialog
        :close-icon="closeIcon"
        :title="title"
        align-center
        :model-value="dialogVisible"
        v-bind="attr"
        :close-on-click-modal="false"
        @close="hiddleClose"
        :width="width || null"
    >
        <slot></slot>
    </el-dialog>
</template>
<script setup lang="tsx">
import Icon from '@/components/Icon/src/Icon.vue';
interface DiaglogProps {
    title?: String;
    dialogVisible: boolean;
    width?: string | number;
    handleCancel?: Function;
    handleConfirm?: Function;
    closeCancel?: boolean;
    closeConfirm?: boolean | number;
}
const closeIcon = () => {
    return <Icon size={16} icon={'svg-icon:close'} />;
};
const attr = useAttrs();
const emit = defineEmits<{
    (e: 'update:dialogVisible', dialogVisible: Boolean): void;
}>();

withDefaults(defineProps<DiaglogProps>(), {  })
const hiddleClose = () => {
    emit('update:dialogVisible', false);
};
</script>

